import React from 'react'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'

import MultipleMenuSection from '../MultipleMenuSection'

import { getIDs, getNames } from '../../helpers/parse'
import { selectTaskStatus, fetchStatus } from '@SonarCX/slices/taskStatus'
import { useTaskFilters } from '@SonarCX/providers/TaskFiltersProvider'

type StatusFilterProps = {
  checkFilters?: boolean
  menuMode?: boolean
  closeModal?: () => void
}

const StatusFilter: React.FC<StatusFilterProps> = props => {
  const dispatch = useAppDispatch()

  const { statuses, loaded, loading } = useAppSelector(selectTaskStatus)

  const { state, handleChange } = useTaskFilters()

  // Fetch statuses if not loaded
  React.useEffect(() => {
    if (!loaded && !loading) {
      dispatch(fetchStatus())
    }
  }, [loaded, loading, dispatch])

  return (
    <MultipleMenuSection
      title='Statuses'
      options={getIDs(statuses)}
      value={state.statusValue}
      setValue={handleChange('statusValue')}
      transform={getNames(statuses)}
      unassignedOpt='All Statuses'
      {...props}
    />
  )
}

export default StatusFilter
